import diacritic from 'diacritic';

export function diacriticSort(
  currentValue: string,
  nextValue: string
): -1 | 0 | 1 {
  const current = currentValue.toLowerCase();
  const next = nextValue.toLowerCase();

  if (diacritic.clean(current) > diacritic.clean(next)) {
    return 1;
  }

  if (diacritic.clean(current) < diacritic.clean(next)) {
    return -1;
  }

  return 0;
}
